export default "__VITE_ASSET__V5paiKtu__"